import React from 'react'
import { Modal } from 'react-bootstrap';
import { Errors } from '../../../Component/Error';
import { SearchAbleSelectBox, SelectBox } from '../../../Component/Inputs';
import { ageGroups, TreatmentPlanType } from '../../../Context/constants';

const PlanClone = ({ methods, data }) => {
    const {
        handleOpenModal,
        handleClosedModal,
        handleClonePlan,
    } = methods
    const {
        testReport,
        openModal,
        CustomButton,
    } = data
    return (
        <>
            <Modal size='lg' show={openModal?.clonePlan} centered>
                <Modal.Body className='pb-0'>
                    <div >
                        <p className="modal-title mb-0">Create Treatment Plan </p>
                    </div>
                    <div className="modal-body  cus-i">
                        <div className="row">
                            <div className="col-lg-6 mb-1">
                                <label className="form-label mb-0">Name<span className='Star_Mark'>*</span></label>
                                <input maxLength={100} type="text" name='name' className="form-control" id="exampleInputEmail1"
                                    value={handleClonePlan?.values.name} onChange={(e) => handleClonePlan.setFieldValue("name", e.target.value)} aria-describedby="emailHelp"
                                    onInput={(e) => { if (e.target.value.length > 100) e.target.value = e.target.value.slice(0, 100); }}
                                />
                                <Errors formikfun={handleClonePlan} name={"name"} />
                            </div>

                            <div className="col-lg-6 mb-1">
                                <label className="form-label mb-0">Plan Type<span className='Star_Mark'>*</span></label>
                                <SelectBox
                                    placeholder="Select Medicine Type"
                                    value={handleClonePlan?.values?.planType}
                                    name="planType"
                                    keys="value"
                                    label="label"
                                    menuValeu="value"
                                    handleChange={(e) => handleClonePlan?.setFieldValue("planType", e.target.value)}
                                    option={TreatmentPlanType}
                                />
                                <Errors formikfun={handleClonePlan} name={"planType"} />
                            </div>
                            {
                                handleClonePlan.values.planType === "Others" && <div className="col-lg-6 mb-1 ">
                                    <label className="form-label mb-0">Other Plan Type<span className='Star_Mark'>*</span></label>
                                    <input type="text" maxLength={50} className="form-control" value={handleClonePlan.values.planTypeField}
                                        onChange={(e) => handleClonePlan.setFieldValue("planTypeField", e.target.value)} />
                                    <Errors formikfun={handleClonePlan} name={"planTypeField"} />


                                </div>
                            }
                            <div className="col-lg-6 mb-1">
                                <label className="form-label mb-0">Age Group<span className='Star_Mark'>*</span></label>
                                <SearchAbleSelectBox
                                    multiple={openModal?.data ? false : true}
                                    option={ageGroups}
                                    getOptionLabel="label"
                                    isOptionEqualToValue="value"
                                    value={handleClonePlan.values.ageGroup}
                                    name={`ageGroup`}
                                    handalSearchAbleSelectBox={(event, newValue, name) => {
                                        handleClonePlan.setFieldValue(name, newValue);
                                    }}
                                />
                                <Errors formikfun={handleClonePlan} name={"ageGroup"} />
                            </div>

                            <div className="col-lg-6 mb-1 ">
                                <label className="form-label mb-0">Test</label>
                                <SearchAbleSelectBox
                                    multiple={true}
                                    option={testReport}
                                    getOptionLabel="name"
                                    isOptionEqualToValue="id"
                                    value={handleClonePlan.values.tests}
                                    name={`tests`}
                                    handalSearchAbleSelectBox={(event, newValue, name) => {
                                        handleClonePlan.setFieldValue(name, newValue);
                                    }}
                                />
                            </div>
                            <div className="col-lg-12 mb-1">
                                <label className="form-label mb-0">Follow Up</label>
                                <textarea
                                    className="form-control mb-1"
                                    onChange={(e) => handleClonePlan?.setFieldValue(`followUp`, e.target.value)}
                                    value={handleClonePlan?.values?.followUp || ""}
                                    name={`followUp`}
                                />
                            </div>
                        </div>
                        <div className=" row ">
                            <div className="col-sm-12 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end justify-content-xl-end justify-content-xxl-end ">
                                <CustomButton className='me-2' variant="outlined" onClick={() => { handleOpenModal("add"); handleClosedModal("clonePlan") }} >Cancel </CustomButton>
                                <CustomButton className='' variant="contained" onClick={handleClonePlan.handleSubmit} >Save</CustomButton>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal >
        </>
    )
}

export default PlanClone
